import { PricingModules } from '../../../../context/contexts/PricingModuleContext';
import { SUBCATEGORIES } from '../../common/categories';
import { SHOWSTOPPER_PROP_OPTIONS, TOOLTIP_PROP_OPTIONS } from '../../../common/LockedFeatures';
import { DisabledDisplayOptions, DisplayConfig, RequiredModuleState } from './types';
import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';

export const HIDDEN_TABS_CONFIG: { [tabId: string]: DisplayConfig } = {
    [SUBCATEGORIES.APPLICATION_SETTINGS.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [SUBCATEGORIES.DESKTOP_MESSAGING_SERVICES.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [SUBCATEGORIES.OTP_NOTIFICATION.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [SUBCATEGORIES.ADFS_FEDERATED_APPS.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.TOOLTIP,
        tooltipProps: TOOLTIP_PROP_OPTIONS.MFA_MODULE_REQUIRED
    },
    [SUBCATEGORIES.PING_FEDERATED_APPS.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.TOOLTIP,
        tooltipProps: TOOLTIP_PROP_OPTIONS.MFA_MODULE_REQUIRED
    },
    [SUBCATEGORIES.AZURE_CONNECTORS.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.TOOLTIP,
        tooltipProps: TOOLTIP_PROP_OPTIONS.MFA_MODULE_REQUIRED
    },
    [SUBCATEGORIES.NEW_AZURE_CONNECTORS.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.TOOLTIP,
        tooltipProps: TOOLTIP_PROP_OPTIONS.MFA_MODULE_REQUIRED
    },
    [SUBCATEGORIES.OKTA_CONNECTORS.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.TOOLTIP,
        tooltipProps: TOOLTIP_PROP_OPTIONS.MFA_MODULE_REQUIRED
    },
    [SUBCATEGORIES.SSO_APPS.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.SHOWSTOPPER,
        showstopperProps: SHOWSTOPPER_PROP_OPTIONS.MFA_MODULE_REQUIRED
    },
    [SUBCATEGORIES.RADIUS_CLIENTS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: {
                requiredState: RequiredModuleState.ON_PREM_ENABLED,
                disabledDisplayOption: DisabledDisplayOptions.HIDDEN
            },
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        moduleMatchLogic: 'ALL',
        disabledDisplayOption: DisabledDisplayOptions.TOOLTIP,
        tooltipProps: TOOLTIP_PROP_OPTIONS.MFA_MODULE_REQUIRED
    },
    [SUBCATEGORIES.SF_SUPPORT.ID]: {
        hiddenBySystemModes: [SYSTEM_MODES.ON_PREM],
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [SUBCATEGORIES.ENROLLMENT_SETTINGS.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [SUBCATEGORIES.SMTP_SERVER.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [SUBCATEGORIES.FAIL_CLOSE.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [SUBCATEGORIES.SELECTIVE_FORWARDING.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [SUBCATEGORIES.SECURITY_MAIN.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [SUBCATEGORIES.ADFS_AND_MFA.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [SUBCATEGORIES.ELASTIC_CONFIG.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [SUBCATEGORIES.MOBILE_MESSAGING_SERVICES.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [SUBCATEGORIES.SYSLOG_SERVER.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [SUBCATEGORIES.EMAIL.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [SUBCATEGORIES.ADMIN_SECURITY_ROLES.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    }
};
